import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Zap, Users, BarChart3, Clock } from 'lucide-react';
const benefits = [{
  icon: Zap,
  text: 'Reduce resume screening time by up to 90%'
}, {
  icon: Users,
  text: 'Improve candidate quality and consistency'
}, {
  icon: CheckCircle2,
  text: 'Remove manual bottlenecks from hiring'
}, {
  icon: BarChart3,
  text: 'Scale as your business grows'
}];
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-76">
      <div className="max-w-7xl mx-auto px-6" data-id="element-77">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-78">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-79">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-80">
              AI Consulting for Hiring – <br className="hidden md:block" data-id="element-81" />
              <span className="text-blue-700" data-id="element-82">
                Built Specifically for Small Businesses
              </span>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-83">
              We design, implement, and manage AI-powered hiring workflows that
              fit your actual process. No generic tools. No bloated software.
              Just AI that works inside your real hiring process.
            </p>

            <div className="space-y-6" data-id="element-84">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-85">
                  <div className="mt-1 bg-blue-50 p-2 rounded-full" data-id="element-86">
                    <benefit.icon className="w-5 h-5 text-blue-600" data-id="element-87" />
                  </div>
                  <span className="text-lg text-slate-800 font-medium" data-id="element-88">
                    {benefit.text}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative h-full min-h-[400px] bg-slate-50 rounded-2xl border border-slate-100 p-8 flex flex-col justify-center items-center text-center overflow-hidden" data-id="element-89">
            <div className="absolute inset-0 bg-grid-slate-200/50 [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] -z-10" data-id="element-90" />

            <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full mb-6 transform rotate-[-2deg]" data-id="element-91">
              <div className="flex items-center gap-3 mb-4" data-id="element-92">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-93">
                  <span className="text-blue-600 font-bold" data-id="element-94">AI</span>
                </div>
                <div className="text-left" data-id="element-95">
                  <div className="font-bold text-slate-900" data-id="element-96">
                    Candidate Score
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-97">
                    Automated Analysis
                  </div>
                </div>
                <div className="ml-auto text-green-600 font-bold" data-id="element-98">98%</div>
              </div>
              <div className="h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-99">
                <div className="h-full bg-blue-500 w-[98%]" data-id="element-100" />
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full transform rotate-[2deg]" data-id="element-101">
              <div className="flex items-center gap-3 mb-2" data-id="element-102">
                <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center" data-id="element-103">
                  <Clock className="w-4 h-4 text-amber-600" data-id="element-104" />
                </div>
                <div className="text-left" data-id="element-105">
                  <div className="font-bold text-slate-900" data-id="element-106">Time Saved</div>
                </div>
                <div className="ml-auto text-slate-900 font-bold" data-id="element-107">
                  12 hrs/week
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}